import { formatWithCents, type CompactUsdOptions } from './compact-usd';

/**
 * A served dollar figure as a compact dollar string. A decimal string
 * ("8020000.00") is formatted from its own digits, never through a float;
 * a number must be finite. Anything else (absent, signed, a word, NaN)
 * reads as `empty`, default the em dash, never "$NaN". At two places an
 * amount below a thousand shows both cents or none ("$715.50", "$704").
 */
export function formatUsdFigure(
  value: string | number | null | undefined,
  {
    maximumFractionDigits = 1,
    minimumFractionDigits = 0,
    empty = '—'
  }: CompactUsdOptions & { empty?: string } = {}
): string {
  if (value == null) return empty;
  const digits = { maximumFractionDigits, minimumFractionDigits };
  if (typeof value === 'number') {
    return Number.isFinite(value) ? formatWithCents(value, digits) : empty;
  }
  if (!/^\d+(?:\.\d+)?$/.test(value)) return empty;
  try {
    return formatWithCents(value as `${number}`, digits);
  } catch {
    return empty;
  }
}
